import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class PulseCdnStorage extends Service<PulseCdnStorageDto> {
  static Schema = z.object({
    enabled: z.boolean(),
  });

  enabled = false;

  constructor(dto: PulseCdnStorageDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      enabled: observable,
    });

    Object.assign(this, dto);
  }

  toJSON(): RequireAllProps<PulseCdnStorageDto> {
    return {
      ...super.toJSON(),
      enabled: this.enabled,
    };
  }
}

export interface PulseCdnStorageDto extends ServiceDto {
  enabled?: boolean;
}

export interface PulseCdnConnectDto {
  apiBaseUrl: string;
  apiToken: string;
  cdnBaseUrl: string;
  storageId: number;
}
